import { render, staticRenderFns } from "./BoardLayout.vue?vue&type=template&id=7c87f347&"
import script from "./BoardLayout.vue?vue&type=script&lang=js&"
export * from "./BoardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports